import React from 'react';

import { graphql } from 'gatsby';

import { Data, Location } from '../../../types';
import { BottomNavigation } from '../../components/BottomNavigation';
import { CustomMDXRenderer } from '../../components/CustomMDXRenderer';
import { Outdated } from '../../components/Outdated';
import { PageContent } from '../../components/PageContent';
import { PageHeader } from '../../components/PageHeader';
import { SideSheet } from '../../components/SideSheet';
import { useImagesLoaded } from '../../hooks/useImagesLoaded';

import { DocumentationSettings } from './DocumentationSettings';
import * as classes from './style.module.scss';

interface Props {
  data: Data;
  location: Location;
}

const DocumentationTemplate: React.FC<Props> = ({ data, location }) => {
  const { pathname } = location;
  const { file } = data;
  const { frontmatter, body, mdxAST } = file.childMdx;

  const { contentRef, imagesLoaded } = useImagesLoaded();

  return (
    <main className={classes.main}>
      <PageContent ref={contentRef}>
        <Outdated />
        <DocumentationSettings />
        <PageHeader
          title={frontmatter.title}
          description={frontmatter.description}
        />
        <CustomMDXRenderer body={body} />
        <BottomNavigation pathname={pathname} />
      </PageContent>
      <SideSheet
        title={frontmatter.title}
        imagesLoaded={imagesLoaded}
        contentRef={contentRef}
        mdxAST={mdxAST}
      />
    </main>
  );
};

// note: has to be default export for gatsby-ssr
// eslint-disable-next-line import/no-default-export
export default DocumentationTemplate;

export const pageQuery = graphql`
  query DocQuery($id: String) {
    site {
      siteMetadata {
        siteName
        siteImage
        description
      }
    }
    file(id: { eq: $id }) {
      childMdx {
        frontmatter {
          title
          description
          image
          canonical
          metaTitle
        }
        body
        mdxAST
        fields {
          contentSwitcherValues
        }
      }
    }
  }
`;
